import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPage} from './login/login.component';
import {ZoneSelectionPage} from './zone-selection/zone-selection.component';
import {FavoritesPage} from './favorites/favorites.component';
import {SchedulerPage} from './scheduler/scheduler.component';
import {SearchPage} from './search/search.component';
import {SettingsPage} from './settings/settings.component';
import {AuthGuard} from '../guards/auth.guard';
import {PlayerGuard} from '../guards/player.guard';
import {BlacklistPage} from './blacklist/blacklist.component';
import {WishlistPage} from './wishlist/wishlist.component';
import {environment} from '../../environments/environment';
import {LoginDesktopComponent} from './login/login-desktop/login-desktop.component';
import {SchedulerModifierPage} from './scheduler-modifier/scheduler-modifier.component';
import {DuplicateDayPageComponent} from './duplicate-day-page/duplicate-day-page.component';
import {EditSchedulerPageComponent} from './edit-scheduler-page/edit-scheduler-page.component';
import {EditSlotPageComponent} from './edit-slot-page/edit-slot-page.component';
import {PendingChangesGuard} from '../guards/pending-changes.guard';
import { HistoryListPage } from './history/history.component';

export { RouterModule } from '@angular/router';


const routes: Routes = [
  environment.enableDesktopMode ? { path: 'login', component: LoginDesktopComponent } : { path: 'login', component: LoginPage },
  environment.enableDesktopMode ? { path: 'zones', component: ZoneSelectionPage } :
  { path: 'zones', component: ZoneSelectionPage, canActivate: [AuthGuard] },
  {
    path: 'scheduler',
    component: SchedulerPage,
    canActivate: [AuthGuard, PlayerGuard],
    data: {
      context: 'SCHEDULE_WEEKLY'
    }
  },
  {
    path: 'scheduler-modifier',
    component: SchedulerModifierPage,
    canActivate: [AuthGuard, PlayerGuard]
  },
  {
    path: 'duplicate-page',
    component: DuplicateDayPageComponent,
    canActivate: [AuthGuard, PlayerGuard]
  },
  {
    path: 'edit-scheduler-page',
    component: EditSchedulerPageComponent,
    canActivate: [AuthGuard, PlayerGuard]
  },
  {
    path: 'edit-slot-page',
    component: EditSlotPageComponent,
    canActivate: [AuthGuard, PlayerGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'library',
    loadChildren : () => import('./library/library.module').then(m => m.LibraryModule),
  },
  {
    path: 'wishlist',
    component: WishlistPage,
    canActivate: [AuthGuard, PlayerGuard],
    data: {
      context: 'PLAYLIST'
    }
  },
  {
    path: 'favorites',
    component: FavoritesPage,
    canActivate: [AuthGuard, PlayerGuard],
    data: {
      context: 'FAVORITE'
    }
  },
  {
    path: 'blacklist',
    component: BlacklistPage,
    canActivate: [AuthGuard, PlayerGuard]
  },
  {
    path: 'search',
    component: SearchPage,
    canActivate: [AuthGuard, PlayerGuard]
  },
  {
    path: 'settings',
    component: SettingsPage,
    canActivate: [AuthGuard, PlayerGuard],
  },
  {
    path: 'history',
    component: HistoryListPage,
    canActivate: [AuthGuard, PlayerGuard]
  },
  { path: '', redirectTo: '/library', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
